import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import React, { useState, useEffect } from 'react';

import { GoalExpansionTemplate } from '../goalExpansionTemplate/GoalExpansionTemplate';
import { useGetCoachingGoalQuery } from '../goalSlice';
import './GoalGrid.scss';

interface GoalGridProps {
    authorId: string;
    recipientId: string;
    setViewState: (viewState: 'read' | 'edit' | 'new') => void;
    setDisplayModal: (displayModal: boolean) => void;
    displayModal: boolean;
    inputMonth: number;
    inputYear: number;
}
const CheckboxLockColumn = (rowData: any) => {
    return <Checkbox className="readCheckbox" checked={rowData.goal_locked} readOnly />;
};
const CheckboxReviewedColumn = (rowData: any) => {
    return <Checkbox className="readCheckbox" checked={rowData.reviewed} readOnly />;
};
const renderTarget = (rowData: any) => {
    return rowData?.target_goal_value || '--';
};
const renderActual = (rowData: any) => {
    return rowData?.actual_goal_value || '--';
};
export const GoalGrid = (props: GoalGridProps) => {
    const now = new Date();
    const maxDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const [goalDate, setGoalDate] = useState<Date | string>('');
    const [expandedRows, setExpandedRows] = useState<any>([]);

    const { data: coachingGoalsData } = useGetCoachingGoalQuery(
        {
            authorId: props.authorId,
            recipientId: props.recipientId,
            year: props.inputYear,
            month: props.inputMonth,
        },
        { skip: !props.displayModal }
    );

    useEffect(() => {
        setGoalDate(new Date(props.inputYear, props.inputMonth - 1, 1))
    }, [props.inputMonth, props.inputYear])

    const coachingGoals = {
        ...coachingGoalsData,
        data: coachingGoalsData?.data?.filter((goal: any) => {
            return goal.employee_number === props.recipientId;
        }),
    };
    const handleCancel = (id: number) => {
        const updatedExpandedRows = { ...expandedRows };
        delete updatedExpandedRows[id];
        setExpandedRows(updatedExpandedRows);
    };

    const rowExpansionTemplate = (data: any) => {
        return (
            <GoalExpansionTemplate
                data={data}
                handleCancel={handleCancel}
                setViewState={props.setViewState}
                receiverId={props.recipientId}
                receiverName={data.author_name}
                goalId={data.coaching_goal_id}
            />
        );
    };

    const allowExpansion = (rowData: any) => {
        if (rowData) return true;

        return false;
    };
    const renderHeader = () => {
        return (
            <>
                <div className="d-flex justify-content-between mb-2">
                    <h3>Goals</h3>
                    <Button
                        label="New Goal"
                        icon="btnPlusIcon"
                        className="btn-primary me-2 p-2"
                        onClick={() => props.setViewState('new')}
                        disabled={coachingGoals?.data?.length >= 10}
                    />
                </div>
                <div>Month</div>
                <Calendar
                    id="goal-date"
                    value={goalDate}
                    view="month"
                    dateFormat="M-yy"
                    onChange={(e: any) => {
                        setGoalDate(e.value);
                    }}
                    showIcon
                    className="custom-calendar mb-2"
                    maxDate={maxDate}
                />

                <div className="splitSection mb-2" />
            </>
        );
    };
    return (
        <Dialog
            className="card shadow bg-body rounded mt-4 border-0"
            header={renderHeader()}
            visible={props.displayModal}
            onHide={() => {
                props.setDisplayModal(false);
                props.setViewState('read');
            }}
            style={{
                width: '66vw',
                height: '90vh',
            }}
            position="top-right"
            modal
            draggable={false}
            resizable={false}
        >
            <h3 className="mb-2 mt-2">Goal Assigned to Associate</h3>
            <DataTable
                value={coachingGoals?.data}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="coaching_goal_id"
                // tableStyle={{ minWidth: '60rem' }}
                className="goalDatatable"
            >
                <Column field="goal_title" header="Goal" />
                <Column field="target_goal_value" header="Target" body={renderTarget} />
                <Column field="actual_goal_value" header="Actual" body={renderActual} />
                <Column field="goal_locked" header="Locked" body={CheckboxLockColumn} />
                <Column field="reviewed" header="Reviewed" body={CheckboxReviewedColumn} />
                <Column expander={allowExpansion} />
            </DataTable>
        </Dialog>
    );
};
